import { render, staticRenderFns } from "./RefundedChatMessage.htm?vue&type=template&id=b9fa2ec0&scoped=true&"
import script from "./RefundedChatMessage.ts?vue&type=script&lang=js&"
export * from "./RefundedChatMessage.ts?vue&type=script&lang=js&"
import style0 from "./RefundedChatMessage.scss?vue&type=style&index=0&id=b9fa2ec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fa2ec0",
  null
  
)

export default component.exports